export const purchase = {
  title: "ポイント購入",
  currentPoint: "現在のポイント",
  unitPt: "pt",
  savings: (args: { percent: string | number }) => `+${args.percent}%`,
  cancel: "キャンセル",
  contact: "ご質問がございましたらお問い合わせください",
  package: {
    p550: "550pt",
    p2000: "2,000pt",
    p3600: "3,600pt",
    p8000: "8,000pt",
    p12000: "12,000pt",
  },
  badge: {
    popular: "人気",
    best: "ボリュームプラン",
    // 幅の狭いカード用の 2 行表示（1 行目＋「プラン」）
    popularLine1: "人気",
    bestLine1: "ボリューム",
    line2Plan: "プラン",
    starter: "お試し",
  },
  tag: {
    popular: "人気No.1",
    bestValue: "一番お得",
    recommended: "イチオシ",
  },
  bonus: {
    ribbonFirst: "今だけ初回購入限定",
    ribbonNth: (args: { count: string | number }) =>
      `今だけ${args.count}回目購入限定`,
    // 限定コースヒーローのバナーラベル（「コース」付き）
    courseFirst: "初回購入限定コース",
    courseNth: (args: { count: string | number }) =>
      `${args.count}回目購入限定コース`,
    regular: (args: { points: string | number }) => `通常${args.points}pt`,
    gain: (args: { points: string | number }) =>
      `通常購入よりも${args.points}ptお得`,
    // 限定コースの増量バッジ（例: ＋1,000pt 増量!）
    increase: (args: { points: string | number }) => `＋${args.points}pt 増量!`,
    // 増量シール（丸バッジ）の文言
    multiplierCaption: "ポイント",
    multiplier: (args: { times: string | number }) => `${args.times}倍`,
    limitedPrefix: "今だけ・",
    limitedOnce: "1人1回かぎり",
    // ライブ下部の丸ポイントボタンに重ねる極小バッジ（フルテキストが乗らない幅のため短縮表記）
    compactBadge: "お得",
  },
  tabs: {
    iap: "アプリ内課金",
    webLine2: "クレジットカード",
    paidy: "Paidy",
    webBadge: "お得",
  },
  banner: {
    web: (args: { wallet: string | number }) =>
      `${args.wallet} またはクレジットからのご購入でボーナスポイント付与`,
    paidy: "Paidyからのご購入でボーナスポイント付与",
  },
  cta: {
    suffix: "を購入",
  },
  confirm: {
    title: "購入内容を確認",
    acquiredPoints: "取得ポイント",
    payment: "お支払い",
    savings: "お得",
    savingsLabel: "お得額",
    methodPicker: "お支払い方法",
    payButton: "を支払う",
    statementNote: "※明細には「JUMBO.K.K」と表示されます",
    email: "メールアドレス",
    required: "必須",
  },
  method: {
    applepay: {
      label: "Apple Pay",
      sub: "•••• 4242",
    },
    card: {
      label: "クレジットカード",
      sub: "VISA •••• 1234",
    },
    paidy: {
      label: "Paidy",
      processing: "決済実行中です。このままお待ちください。",
    },
  },
  wallet: {
    applePay: "Apple Pay",
    googlePay: "Google Pay",
    genericWallet: "ウォレット決済",
    creditCard: "クレジットカード",
    unavailableError: (args: { wallet: string | number }) =>
      `${args.wallet}を取得できないためクレジットカード決済をご利用ください`,
    cardNumber: "カード番号",
    expiry: "有効期限",
    cvc: "セキュリティコード",
    saveCard: "次回のためにお支払い情報を保存する",
    emailRequiredError: "メールアドレスは必須です",
    linkPromotion: "Linkに登録すると次回以降ワンタップで支払いを行えます。",
  },
  success: {
    title: "購入完了",
    message: "ポイントが付与されました",
    ok: "OK",
  },
  alreadyProcessed:
    "この購入はすでに処理済みです。ポイントは反映されています。",
  paymentError: {
    title: "決済に失敗しました",
    message: "設定ページのお問い合わせからお問い合わせください。",
    ok: "OK",
  },
  error: {
    generic: "購入に失敗しました",
    notInApp: "アプリ内で開いてください",
    captureRetryLater:
      "お支払いの確定に失敗しました。時間をおいて再度お試しください。",
    pointGrantFailed:
      "ポイントの付与に失敗しました。サポートにお問い合わせください。",
    pointGrantAlreadyFailed:
      "決済は完了しましたが、ポイント付与に問題があります。サポートにお問い合わせください。",
    purchaseStatusUnknown:
      "購入状況を確認できませんでした。お手数ですが、設定ページのお問い合わせよりご連絡ください。",
    noNetwork:
      "インターネットに接続されていません。通信環境をご確認のうえ、もう一度お試しください。",
    purchaseRestricted:
      "このデバイスでは購入が制限されています。設定をご確認ください。",
    notAvailable:
      "現在この商品を購入できません。しばらくしてから再度お試しください。",
    pending: "購入が保留中です。承認されると自動的に反映されます。",
    verificationFailed: "購入の確認に失敗しました。もう一度お試しください。",
    paidyCaptureFailed: "Paidy 決済処理に失敗しました",
    stripeCaptureFailed: "決済処理に失敗しました",
  },
  points: "ポイント",
  buy: "購入する",
  webPurchase: "クレジットカードで購入",
  nativePurchase: "アプリ内購入",
  stripeDisabled: "Web決済は現在ご利用いただけません",
  payment: {
    addPoints: "ポイントを追加",
    billingNote: "お支払いはStripeにより安全に処理されます",
    walletTab: "ウォレット",
    cardTab: "クレジットカード",
    processing: "処理中...",
    pay: "支払う",
    close: "閉じる",
  },
} as const;
